<template>
  <w-modal
    v-model="show"
    :submit-button="$t('buttons.close')"
    :title="title"
    :show-close-button="false"
    :close-on-submit="true"
    :hideOnOverlay="true"
    :hideOnEsc="true"
    @submit="$emit('close')"
    @close="$emit('close')"
  >
    <div class="row">
      <p style="height: 400px;" class="scroll-text" v-html="text" />
    </div>
  </w-modal>
</template>

<script>
import WModal from '@witkac/bootstrap4-components/src/components/modal.vue';

// @vuese
// Modal wyświetlający treść
// @group Components
export default {
  components: { WModal },
  props: {
    // Pokazywanie modala
    show: {
      type: Boolean,
      required: true
    },
    // Tytuł modala
    title: {
      type: String,
      required: true
    },
    // Treść modala
    text: {
      type: String,
      required: true
    }
  }
};
</script>
